/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Domain_ProcurementInputs */

const en_search_domain_procurement = /** @type {(inputs: Search_Domain_ProcurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the purchase orders`)
};

/**
* | output |
* | --- |
* | "the purchase orders" |
*
* @param {Search_Domain_ProcurementInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_domain_procurement = /** @type {((inputs?: Search_Domain_ProcurementInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Domain_ProcurementInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_domain_procurement(inputs)
});